/**
 * Social demo entry options (offline /demo flows).
 * Class demo uses a separate chooser (demoClassChooser) → /demo/class*.
 * School marketing deep-links from home still point at seeded product routes.
 */

export const DEMO_CHOOSER_CTA = "Try the demo →";
export const HOST_DEMO_CTA = "Try the host demo →";
export const HOST_DEMO_PATH = "/demo/host?demo=true";

export const DEMO_CHOOSER_MODAL = {
  title: "Choose your demo",
};

export const DEMO_CHOOSER_OPTIONS = [
  {
    id: "guest",
    label: "I'm a guest",
    description: "Test RSVPs, check-ins, and voting. (2 min)",
    to: "/demo?demo=true",
    testId: "demo-chooser-guest",
  },
  {
    id: "host",
    label: "I'm a host",
    description: "Explore guest lists, invitations, and exports. (5 min)",
    to: HOST_DEMO_PATH,
    testId: "demo-chooser-host",
  },
];
